/* Milagron · Favoriler misafir penceresi (Growave "e-postanı gir" + "Ürün eklendi")
   Growave penceresi shadow DOM içinde; kalbe tıklanınca pencereyi bulur, stil ekler ve
   başarı ekranını yeniden düzenler. Sayfa genelinde gözlemci yok: sadece pencerenin kendi içi izlenir. */
(function () {
  if (window.__mgWlg) return; window.__mgWlg = 1;
  var FAV = '/pages/favorilerim';
  var CSS = [
    '.gw-wl-save-guest-item-modal-dialog{border-radius:22px!important;transition:opacity .18s ease}',
    /* Başarı ekranı */
    '.gw-wl-save-guest-item-modal-dialog:has(.mgwg) .gw-modal-dialog__body>.gw-block-stack{display:none!important}',
    '.mgwg{display:flex;flex-direction:column;align-items:center;text-align:center;padding:6px 6px 2px;font-family:inherit;color:#141414}',
    '.mgwg-ic{position:relative;width:68px;height:68px;border-radius:50%;background:#141414;color:#fff;display:flex;align-items:center;justify-content:center;animation:mgwgPop .5s cubic-bezier(.2,1.5,.4,1) both}',
    '.mgwg-ic svg{width:30px;height:30px}',
    '.mgwg-ic::before{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid #141414;animation:mgwgRing 1.2s ease-out .25s both}',
    '.mgwg-ok{position:absolute;right:-2px;bottom:-2px;width:24px;height:24px;border-radius:50%;background:#1f7a3a;border:3px solid #fff;display:flex;align-items:center;justify-content:center;animation:mgwgPop .4s cubic-bezier(.2,1.5,.4,1) .2s both}',
    '.mgwg-ok svg{width:12px;height:12px}',
    '.mgwg-t{display:block;margin-top:18px;font-size:21px;line-height:1.25;font-weight:800;letter-spacing:-.01em}',
    '.mgwg-s{margin:6px 0 0;font-size:14px;line-height:1.5;color:#6f6a64;max-width:320px}',
    '.mgwg-b{display:flex;gap:10px;width:100%;margin-top:24px}',
    '.mgwg-btn{flex:1 1 0;min-width:0;height:50px;padding:0 12px;border-radius:14px;border:1px solid #141414;display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:inherit;font-size:14px;font-weight:700;line-height:1;text-decoration:none!important;cursor:pointer;white-space:nowrap;transition:background .15s,color .15s,transform .1s;box-sizing:border-box}',
    '.mgwg-btn:active{transform:scale(.98)}',
    '.mgwg-btn--p{background:#141414;color:#fff!important}',
    '.mgwg-btn--p:hover{background:#2b2b2b}',
    '.mgwg-btn--s{background:#fff;color:#141414!important;border-color:#dedad3}',
    '.mgwg-btn--s:hover{border-color:#141414}',
    '.mgwg-btn svg{width:16px;height:16px;flex:none}',
    '.mgwg-bar{display:block;position:relative;width:100%;height:3px;margin-top:20px;border-radius:3px;background:#eeeae4;overflow:hidden}',
    '.mgwg-bar::after{content:"";position:absolute;inset:0;background:#141414;transform-origin:left center;animation:mgwgBar 5s linear forwards}',
    '.mgwg-hd{display:flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;background:#f4f1ec;color:#141414;margin:0 0 14px}',
    '.mgwg-hd svg{width:22px;height:22px}',
    '@media (max-width:767.98px){.mgwg-hd{display:none}}',
    '@keyframes mgwgPop{from{transform:scale(.4);opacity:0}to{transform:scale(1);opacity:1}}',
    '@keyframes mgwgRing{from{transform:scale(1);opacity:.5}to{transform:scale(1.6);opacity:0}}',
    '@keyframes mgwgBar{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
    '@media (prefers-reduced-motion:reduce){.mgwg *,.mgwg *::before,.mgwg *::after{animation:none!important}}',
    /* Masaüstü: e-posta adımı ve başarı ekranı daha ferah */
    '@media (min-width:768px){',
    '.gw-wl-save-guest-item-modal-dialog{width:460px!important;padding:30px 30px 26px!important;box-shadow:0 30px 80px rgba(0,0,0,.25)!important}',
    '.gw-modal-dialog.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__header.gw-modal-dialog__header{position:absolute!important;top:16px!important;right:16px!important;left:auto!important;width:auto!important;height:auto!important;padding:0!important;margin:0!important;min-height:0!important;border:0!important;background:none!important;z-index:3}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__close-btn{width:34px!important;height:34px!important}',
    '.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__body{padding:0!important}',
    '.gw-modal-dialog.gw-wl-save-guest-item-modal-dialog form .gw-form-field-label>p.gw-text{font-size:20px!important;line-height:1.3!important;font-weight:800!important;letter-spacing:-.01em;padding:0!important;max-width:none!important;width:auto!important}',
    '.gw-modal-dialog.gw-wl-save-guest-item-modal-dialog form .gw-form-field-label{max-width:none!important;width:100%!important}',
    '.gw-wl-save-guest-item-modal-dialog form input{height:52px!important;font-size:15px!important}',
    '.gw-wl-save-guest-item-modal-dialog form .gw-btn{height:52px!important;border-radius:14px!important}',
    '.mgwg{padding:18px 6px 0}',
    '}'
  ].join('');
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.8 4.5c2.1 0 3.6 1.1 4.4 2.5.4.7 1.2.7 1.6 0 .8-1.4 2.3-2.5 4.4-2.5 3.8 0 5.9 3.9 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg>';
  var HEART_O = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M12 20.5s-7.2-4.4-9.2-8.8C1.4 8.5 3.4 5 6.9 5c2 0 3.4 1 4.2 2.4.4.6 1.4.6 1.8 0C13.7 6 15.1 5 17.1 5c3.5 0 5.5 3.5 4.1 6.7-2 4.4-9.2 8.8-9.2 8.8z"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function host() { return document.querySelector('.gw-wl-save-guest-item-modal-widget-placeholder'); }
  function decorate(R) {
    var form = R.querySelector('.gw-wl-save-guest-item-modal-dialog form');
    if (form && !R.querySelector('.mgwg-hd')) {
      var hd = document.createElement('div'); hd.className = 'mgwg-hd'; hd.innerHTML = HEART_O;
      form.parentNode.insertBefore(hd, form);
    }
    var ok = R.querySelector('.gw-wl-save-guest-item-modal-dialog .gw-text--tone-success');
    if (!ok) return;
    var body = ok.closest('.gw-modal-dialog__body');
    if (!body || body.querySelector('.mgwg')) return;
    var d = document.createElement('div');
    d.className = 'mgwg';
    d.setAttribute('role', 'status');
    d.innerHTML = '<div class="mgwg-ic">' + HEART + '<span class="mgwg-ok">' + TICK + '</span></div>' +
      '<b class="mgwg-t">Favorilerine eklendi</b>' +
      '<p class="mgwg-s">Beğendiğin ürünler Favorilerim’de seni bekliyor. Fiyatı düşerse ilk sen haberdar ol.</p>' +
      '<div class="mgwg-b"><button type="button" class="mgwg-btn mgwg-btn--s" data-mgwg-close>Alışverişe devam et</button>' +
      '<a class="mgwg-btn mgwg-btn--p" href="' + FAV + '">Favorilerim' + ARROW + '</a></div>' +
      '<i class="mgwg-bar" aria-hidden="true"></i>';
    body.appendChild(d);
    d.querySelector('[data-mgwg-close]').addEventListener('click', function () {
      var x = R.querySelector('.gw-wl-save-guest-item-modal-dialog .gw-modal-dialog__close-btn');
      if (x) x.click();
    });
  }
  /* Pencere hazır olana kadar (Growave yazıları ve tema stilleri gelene kadar) görünmesin: ilk saniyedeki yarım kutu */
  function ready(R) {
    if (R.querySelector('.mgwg')) return true;
    var d = R.querySelector('.gw-wl-save-guest-item-modal-dialog'); if (!d) return false;
    var lbl = d.querySelector('form .gw-form-field-label p, form p.gw-text');
    var btn = d.querySelector('form button[type="submit"]');
    return !!(R.__mgGw && lbl && lbl.textContent.trim() && btn && btn.textContent.trim());
  }
  function reveal(R) { var h = R.querySelector('style[data-mgwg-hide]'); if (h) h.remove(); }
  function prep(R) {
    if (R.__mgwg) return; R.__mgwg = 1;
    var st = document.createElement('style'); st.setAttribute('data-mg-wlg', ''); st.textContent = CSS; R.appendChild(st);
    var hide = document.createElement('style'); hide.setAttribute('data-mgwg-hide', '');
    hide.textContent = '.gw-wl-save-guest-item-modal-dialog{opacity:0!important}'; R.appendChild(hide);
    var q = 0, seen = 0;
    function tick() {
      q = 0; decorate(R);
      var d = R.querySelector('.gw-wl-save-guest-item-modal-dialog');
      if (!d) { seen = 0; if (!R.querySelector('style[data-mgwg-hide]')) R.appendChild(hide); return; }
      if (!seen) { seen = Date.now(); setTimeout(function () { reveal(R); }, 2500); }
      if (ready(R)) reveal(R);
    }
    new MutationObserver(function () { if (!q) q = requestAnimationFrame(tick); })
      .observe(R, { childList: true, subtree: true, characterData: true });
    tick();
  }
  function attach() {
    var h = host(), R = h && h.shadowRoot;
    if (!R) return false;
    prep(R); decorate(R);
    return true;
  }
  /* Shadow root açıldığı anda stilleri koy (sonradan tarama gecikmesi olmasın) */
  try {
    var oa = Element.prototype.attachShadow;
    if (oa && !oa.__mgwg) {
      var wrapped = function (o) {
        var r = oa.call(this, o);
        try { if (this.classList && this.classList.contains('gw-wl-save-guest-item-modal-widget-placeholder')) prep(r); } catch (e) {}
        return r;
      };
      wrapped.__mgwg = 1;
      Element.prototype.attachShadow = wrapped;
    }
  } catch (e) {}
  attach();
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (!t.closest('[class*="gw-"], [class*="wishlist"], [data-gw-moi-id]')) return;
    if (attach()) return;
    var k = 0, iv = setInterval(function () { if (attach() || ++k > 30) clearInterval(iv); }, 150);
  }, true);
})();

/* Ürün kartı favori kalbi ön gösterimi (.mg-fav-pre, snippets/product-label.liquid).
   Growave kalbi gelmeden tıklanırsa bekler, gelince onun düğmesine basar. */
(function () {
  if (window.__mgFavPre) return; window.__mgFavPre = 1;
  function gwBtn(card) { var b = card && card.querySelector('.gw-add-to-wishlist-product-card-placeholder .gw-toggle-wishlist-product-card-button'); return b; }
  function go(pre) {
    var card = pre.closest('.image-cont') || pre.closest('.product-block');
    var b = gwBtn(card);
    if (b) { b.click(); return; }
    if (pre.classList.contains('is-wait')) return;
    pre.classList.add('is-wait');
    var k = 0, iv = setInterval(function () {
      var x = gwBtn(card);
      if (x || ++k > 75) { clearInterval(iv); pre.classList.remove('is-wait'); if (x) x.click(); }
    }, 200);
  }
  function onAct(e) {
    var t = e.target; if (!t || !t.closest) return;
    var pre = t.closest('.mg-fav-pre');
    if (!pre) {
      /* Growave'in boş kutusu kalbin üstüne gelmiş ama düğmesi henüz yoksa */
      var ph = t.closest('.gw-add-to-wishlist-product-card-placeholder');
      if (ph && !ph.querySelector('.gw-toggle-wishlist-product-card-button') && ph.parentElement) pre = ph.parentElement.querySelector('.mg-fav-pre');
    }
    if (!pre) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault(); e.stopPropagation();
    if (e.type !== 'pointerdown') go(pre);
  }
  document.addEventListener('click', onAct, true);
  document.addEventListener('keydown', onAct, true);
  /* Growave hiç yüklenmezse sahte kalp ekranda kalmasın */
  window.addEventListener('load', function () {
    setTimeout(function () { if (!document.querySelector('.gw-toggle-wishlist-product-card-button')) document.documentElement.classList.add('mg-fav-off'); }, 20000);
  });
})();

